export const findMatchingDeviceByGroupId = (mediaDevices, kind, currentDeviceGroupId) => {
    return (mediaDevices?.find(device => device.kind === kind && device.groupId === currentDeviceGroupId) || null);
};
//# sourceMappingURL=find_matching_device_by_group_id.js.map